import './InfoCards.scss';
import React, {
	ReactElement,
	PropsWithoutRef,
	ReactNode,
	useRef,
	useCallback,
	useState,
} from 'react';
import InfoCard, { CardProps } from './InfoCard/InfoCard';
import Carousel from '../Carousel/Carousel';
import classNames from 'classnames';
import A11yDialogInstance from 'a11y-dialog';
import { translate, getUniqueId } from '@micro-apps/env';
import Dialog from '../Dialog/Dialog';
import Accordion from '../Accordion/Accordion';
type Props = {
	cards: CardProps[];
	readMore?: ReactNode;
};
export default function InfoCards({ cards = [], readMore }: PropsWithoutRef<Props>): ReactElement {
	const [defaultSelected, setDefaultSelected] = useState<number[]>([]);
	const dialog = useRef<A11yDialogInstance>(undefined);
	const getReadMoreLink = useCallback(
		(readMoreNode: ReactNode = readMore || translate('Read More'), index = 0) => {
			return (
				<a
					className="InfoCard-body-readMore text-body3"
					onClick={e => {
						e.preventDefault();
						setDefaultSelected([index]);
						dialog.current?.show();
					}}
				>
					<span className="text-text-primary">{readMoreNode}</span>
				</a>
			);
		},
		[readMore]
	);
	return (
		<>
			{cards.length > 0 ? (
				<div className="InfoCards">
					<div
						className={classNames('InfoCards-mobileCards', {
							'InfoCards-singleCard': cards.length === 1,
						})}
					>
						{cards.length === 1 ? (
							<InfoCard {...cards[0]} readMore={getReadMoreLink()} />
						) : (
							<Carousel
								id="info_cards"
								showDots={true}
								elements={cards.map((card, i) => (
									<InfoCard
										key={i}
										{...card}
										readMore={getReadMoreLink(undefined, i)}
										verticalSpacing
									/>
								))}
							/>
						)}
					</div>

					<div
						className={classNames('InfoCards-nonMobileCards', {
							'InfoCards-singleCard': cards.length === 1,
						})}
					>
						{cards.map((card, i) => (
							<InfoCard key={i} {...card} readMore={getReadMoreLink(undefined, i)} />
						))}
					</div>
					<Dialog
						id={`info-cards-dialog-${getUniqueId()}`}
						dialogRef={instance => (dialog.current = instance)}
						title={translate('Please Note')}
						classNames={{
							container: 'Dialog hidden',
							overlay: 'Dialog-overlay',
							dialog: 'Dialog-wrapper Dialog-wrapper-95',
							title: 'Dialog-title',
							closeButton: 'Dialog-closebutton',
						}}
					>
						<div className="">
							{cards.length === 1 ? (
								<div className="Dialog-content-oneItemContainer">
									<span className="Dialog-content-oneItemTitle ty-c2">{cards[0].title}</span>
									<span className="Dialog-content-oneItemDescription ty-b3">
										<div
											className="InfoCard-html-content"
											dangerouslySetInnerHTML={cards[0].html}
										></div>
										{cards[0].description}
									</span>
								</div>
							) : (
								<Accordion
									elements={cards.map(({ title, description, html }, i) => ({
										title: <span className="ty-c2">{title}</span>,
										titleBorder: i !== 0,
										content: (
											<span className="InfoCards-accordion-content ty-b3">
												<div className="InfoCard-html-content" dangerouslySetInnerHTML={html}></div>
												{description}
											</span>
										),
									}))}
									defaultSelected={defaultSelected}
								/>
							)}
						</div>
					</Dialog>
				</div>
			) : null}
		</>
	);
}
